// import

import {styled} from 'goober';
import {darken} from 'polished';

import {useTheme} from 'modules/Theme';
import type {ColorKey} from 'modules/Theme/theme';

// types

type Props = {
  id: string;
  color: ColorKey;
  flip?: boolean;
  className?: string;
};

// component

export function ZigZag(props: Props) {
  const {id, color, flip, ...rest} = props;
  const theme = useTheme();
  const colorPick = theme.color[color];

  return (
    <Styled
      {...rest}
      style={{
        '--c0': colorPick,
        '--c1': darken(0.1, colorPick),
        '--c2': darken(0.2, colorPick),
        '--c3': darken(0.3, colorPick),
      }}
    >
      <defs>
        <pattern
          height="56"
          id={id}
          patternTransform={flip ? 'rotate(180)' : undefined}
          patternUnits="userSpaceOnUse"
          width="64"
        >
          <path className="c3" d="M 0 32 L 32 0 L 64 32 L 64 56 L 0 56" />
          <path className="c2" d="M 0 36 L 32 4 L 64 36 L 64 56 L 0 56" />
          <path className="c1" d="M 0 44 L 32 12 L 64 44 L 64 56 L 0 56" />
          <path className="c0" d="M 0 56 L 32 24 L 64 56" />
        </pattern>
      </defs>

      <rect fill={`url(#${id})`} height="100%" width="100%" x="0" y="0" />
    </Styled>
  );
}

// styles

const Styled = styled('svg')`
  width: 100%;
  height: 3.5rem;
  display: block;

  .c0 { fill: var(--c0); }
  .c1 { fill: var(--c1); }
  .c2 { fill: var(--c2); }
  .c3 { fill: var(--c3); }
`;
